import readXlsxFile from "read-excel-file/browser";

function parseString(value, removeNewlines = false) {
  if (value === null || value === undefined) return null;
  let parsed = String(value).trim();
  if (removeNewlines) {
    parsed = parsed.replace(/\r\n|\r|\n/g, " ");
  }
  return parsed === "" ? null : parsed;
}

function buildDetailedProduitImportFileFromRows(rows) {
  function rowValue(index, removeNewlines = false) {
    return parseString(rows?.[index]?.[1], removeNewlines);
  }

  const indexMap = {
    nom: 0, // Nom du produit
    nomProducteur: 1, // Nom du producteur
    presentationProducteur: 2, // Présentation du producteur
    presentationProduitMain: 3, // Présentation du produit
    presentationProduitAtouts: 4, // Les atouts du produit
    presentationProduitInconvenients: 6, // Les inconvénients du produit
    ageMin: 7, // Age limte minimum
    ageMax: 8, // Age limite maximum
    typeInvestisseur: 9, // Le client est une personne physique ou une personne morale
    typeInvestisseurProfessionnel: 10, // Arguments pour type d'investisseur professionnel
    typeInvestisseurNonProfessionnel: 11, // Arguments pour type d'investisseur non professionnel
    typeInvestisseurContrepartieEligible: 12, // Arguments pour contrepartie éligible
    professionExclues: 13, // Y-a-t-il des professions exclues? Si oui, lesquelles?
    experienceNovice: 14, // En quoi le produit correspondrait ou non à un investisseur qualifié de novice ?
    experienceInforme: 15, // En quoi le produit correspondrait ou non à un investisseur qualifié d'informé ?
    experienceExperimente: 16, // En quoi le produit correspondrait ou non à un investisseur qualifié d'expérimenté ?
    capacitePerteNulle: 17, // En quoi le produit correspondrait ou non à un client qui n'accepterait aucune perte  ?
    capacitePerteLimitees: 18, // En quoi le produit correspondrait ou non à un client qui accepte une perte financière limitée (moins de 10%) ?
    capacitePerteSignificatives: 19, // En quoi le produit correspondrait ou non à un client qui accepte une perte financière significative (entre 10% et 50%) ?
    capacitePerteJusquaMontants: 20, // En quoi le produit correspondrait ou non à un client qui accepte une perte financière jusqu'à concurrence des montants investis ?
    capacitePerteAuDelaMontants: 21, // En quoi le produit correspondrait ou non à un client qui accepte une perte financière au-delà des montants investis ?
    profilsSecuritaire: 22, // En quoi le produit correspondrait ou non à un profil sécuritaire ?
    profilsDefensif: 23, // En quoi le produit correspondrait ou non à un profil défensif ?
    profilsEquilibre: 24, // En quoi le produit correspondrait ou non à un profil équilibré ?
    profilsDynamique: 25, // En quoi le produit correspondrait ou non à un profil dynamique ?
    profilsOffensif: 26, // En quoi le produit correspondrait ou non à un profil offensif ?
    objectifsConservation: 27, // En quoi le produit correspondrait ou non à un objectif de conservation ?
    objectifsCroissance: 28, // En quoi le produit correspondrait ou non à un objectif de croissance ?
    objectifsRendement: 29, // En quoi le produit correspondrait ou non à un objectif de rendement ?
    objectifsRevenus: 30, // En quoi le produit correspondrait ou non à un objectif de revenus ?
    objectifsCouverture: 31, // En quoi le produit correspondrait ou non à un objectif de couverture ?
    objectifsLevier: 32, // En quoi le produit correspondrait ou non à un objectif d'effet de levier ?
    objectifsAutre: 33, // Autres
    horizonTresCourtTerme: 34, // En quoi le produit correspondrait ou non à un Horizon très court terme (inférieur à 1 an)
    horizonCourtTerme: 35, // En quoi le produit correspondrait ou non à un Horizon court terme (inférieur à 3 ans)
    horizonMoyenTerme: 36, // En quoi le produit correspondrait ou non à un Horizon moyen terme (de 3 à 5 ans)
    horizonLongTerme: 37, // En quoi le produit correspondrait ou non à un Horizon long terme (supérieur à 5 ans)
    declarationAdequation: 38, // Pourquoi le conseiller privilégie ce produit ?
    marcheCiblePositif: 39, // Décrire le marché cible positif
    marcheCibleNegatif: 40, // Décrire le marché cible négatif
    accessiblePersonnesVulnerables: 41, // Produit accessible aux personnes vulnérable? OUI ou NON
  };

  const nomProduit = rowValue(indexMap.nom);
  const nomProducteur = rowValue(indexMap.nomProducteur);

  return {
    nom: nomProduit,
    nom_producteur: nomProducteur,
    documentsPresentation: {
      presentationProduit: (() => {
        const pres = [];
        const main = rowValue(indexMap.presentationProduitMain);
        if (main) {
          pres.push(
            `### Présentation du produit ${nomProduit ?? ""}`,
            "",
            main
          );
        }
        const atouts = rowValue(indexMap.presentationProduitAtouts);
        if (atouts) {
          pres.push(
            "",
            `** Les avantages de ${nomProduit ?? ""} **`,
            "",
            atouts
          );
        }
        const inconvenients = rowValue(
          indexMap.presentationProduitInconvenients
        );
        if (inconvenients) {
          pres.push(
            "",
            `** Les inconvénients de ${nomProduit ?? ""} **`,
            "",
            inconvenients
          );
        }
        return pres;
      })(),
      presentationProducteur: (() => {
        const v = rowValue(indexMap.presentationProducteur);
        return v !== null
          ? [
              `### Présentation de la société de gestion ${
                nomProducteur ?? ""
              }`,
              "",
              v,
            ]
          : [];
      })(),
      declarationAdequation: rowValue(indexMap.declarationAdequation),
    },
    marcheCible: {
      accessible_personnes_vulnerables: rowValue(
        indexMap.accessiblePersonnesVulnerables
      ),
      age_limite_client: {
        min: rowValue(indexMap.ageMin),
        max: rowValue(indexMap.ageMax),
      },
      type_investisseur: {
        professionnel: rowValue(indexMap.typeInvestisseurProfessionnel, true),
        non_professionnel: rowValue(
          indexMap.typeInvestisseurNonProfessionnel,
          true
        ),
        contrepartie_eligible: rowValue(
          indexMap.typeInvestisseurContrepartieEligible,
          true
        ),
      },
      profession_exclues: rowValue(indexMap.professionExclues, true),
      profils: {
        securitaire: rowValue(indexMap.profilsSecuritaire, true),
        defensif: rowValue(indexMap.profilsDefensif, true),
        equilibre: rowValue(indexMap.profilsEquilibre, true),
        dynamique: rowValue(indexMap.profilsDynamique, true),
        offensif: rowValue(indexMap.profilsOffensif, true),
      },
      horizon: {
        tres_court_terme: rowValue(indexMap.horizonTresCourtTerme, true),
        court_terme: rowValue(indexMap.horizonCourtTerme, true),
        moyen_terme: rowValue(indexMap.horizonMoyenTerme, true),
        long_terme: rowValue(indexMap.horizonLongTerme, true),
      },
      objectifs: {
        conservation: rowValue(indexMap.objectifsConservation, true),
        croissance: rowValue(indexMap.objectifsCroissance, true),
        rendement: rowValue(indexMap.objectifsRendement),
        revenus: rowValue(indexMap.objectifsRevenus, true),
        couverture: rowValue(indexMap.objectifsCouverture),
        optionnel_ou_à_effet_de_levier: rowValue(
          indexMap.objectifsLevier,
          true
        ),
        autre: rowValue(indexMap.objectifsAutre, true),
      },
      capacite_perte: {
        nulle: rowValue(indexMap.capacitePerteNulle, true),
        limitées: rowValue(indexMap.capacitePerteLimitees, true),
        significatives: rowValue(indexMap.capacitePerteSignificatives, true),
        jusqua_montants: rowValue(indexMap.capacitePerteJusquaMontants, true),
        au_dela_montants: rowValue(indexMap.capacitePerteAuDelaMontants, true),
      },
      synthese: {
        marche_cible_du_produit_par_le_cabinet: rowValue(
          indexMap.marcheCiblePositif,
          true
        ),
        marche_cible_négatif_du_produit_par_le_cabinet: rowValue(
          indexMap.marcheCibleNegatif,
          true
        ),
      },
    },
    experience: {
      novice_texte: rowValue(indexMap.experienceNovice, true),
      informe_texte: rowValue(indexMap.experienceInforme, true),
      experimente_texte: rowValue(indexMap.experienceExperimente, true),
    },
  };
}

export function initProductFileParser(app) {
  app.ports.parseProductFile.subscribe(async (inputId) => {
    const input = document.getElementById(inputId);
    const file = input?.files?.[0];
    if (!file) {
      app.ports.productFileParsed.send(null);
      return;
    }
    try {
      const rows = await readXlsxFile(input.files[0]);
      const detailedProduitImportFile =
        buildDetailedProduitImportFileFromRows(rows);
      app.ports.productFileParsed.send(detailedProduitImportFile);
    } catch (error) {
      console.error(error);
      app.ports.productFileParsed.send(null);
    }
  });
}
